<template>
  <div class="wechat-store-merchant-binding-page">
    <baseSearch @search="searchFun" :list="searchFrom">
      <template #btns>
        <el-button
          class="btnsty base_but_style"
          icon="el-icon-refresh"
          :loading="search.loading"
          @click="getList"
        >
          刷新
        </el-button>
      </template>
    </baseSearch>
	<div class="base_content mt10">
    <baseTable
      :loading="search.loading"
      :total="search.total"
      :page="search.post.page"
      :pagesize="search.post.limit"
      :list="search.table"
      :tableList="search.tableForm"
      @changePage="changePage"
    >
      <template #store="scope">
        {{ storeName(scope.row) }}
      </template>
      <template #merchant="scope">
        <!-- <div>{{ merchantValue(scope.row, "sub_mchid") || "-" }}</div> -->
        <div class="cell-tips">{{ merchantDisplayName(scope.row) }}</div>
      </template>
	  <template #merchanthao="scope">
	    <div>{{ merchantValue(scope.row, "sub_mchid") || "-" }}</div>
	  </template>
      <template #payment_ready="scope">
        <el-tag size="mini" :type="isPaymentReady(scope.row) ? 'success' : 'warning'">
          {{ isPaymentReady(scope.row) ? "已就绪" : "未就绪" }}
        </el-tag>
      </template>
      <template #platform_ratio="scope">
        {{ ratioText(platformRatio(scope.row)) }}
      </template>
      <template #enabled="scope">
        <el-tag size="mini" :type="isEnabled(scope.row) ? 'success' : 'info'">
          {{ isEnabled(scope.row) ? "已启用" : "已禁用" }}
        </el-tag>
      </template>
      <template #updated_at="scope">
        {{ scope.row.bound_at || scope.row.enabled_at || scope.row.updated_at || "-" }}
      </template>
      <template #action="scope">
        <div class="row-actions">
          <div class="but_primary" @click="openCandidates(scope.row)">更换并启用</div>
          <div
            v-if="isEnabled(scope.row)"
            class="but_primary danger-action"
            @click="disableRow(scope.row)"
          >
            禁用
          </div>
          <div
            v-else-if="bindingId(scope.row)"
            class="but_primary"
            @click="enableRow(scope.row)"
          >
            启用
          </div>
        </div>
      </template>
    </baseTable>
</div>
    <el-dialog class="admin-standard-dialog"
      title="选择收款商户档案"
      :visible.sync="candidateDialog.show"
      width="760px"
      custom-class="merchant-candidate-dialog"
      :close-on-click-modal="false"
    >
      <div class="candidate-toolbar">
        <div class="candidate-meta">
          <div class="candidate-store">{{ storeName(candidateDialog.store) }}</div>
          <div class="base_tips">只展示已完成进件且可用于收款绑定的商户档案。</div>
        </div>
        <div class="candidate-actions">
          <el-input
            v-model.trim="candidateDialog.keyword"
            clearable
            size="small"
            class="candidate-search"
            placeholder="搜索商户号/简称/名称"
            prefix-icon="el-icon-search"
            @input="filterCandidates"
            @clear="filterCandidates"
          />
          <el-button size="small" icon="el-icon-refresh" :loading="candidateDialog.loading" @click="loadCandidates">刷新</el-button>
        </div>
      </div>
      <el-table v-admin-element-table
        v-loading="candidateDialog.loading"
        :data="candidateDialog.list"
        border
        size="small"
        class="candidate-table"
        max-height="420"
        @current-change="handleCandidateChange"
      >
        <el-table-column width="55" align="center">
          <template slot-scope="scope">
            <el-radio
              v-model="candidateDialog.selectedKey"
              :label="candidateKey(scope.row)"
              @change="selectCandidate(scope.row)"
            >
              &nbsp;
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column label="特约商户号" min-width="140">
          <template slot-scope="scope">{{ scope.row.sub_mchid || "-" }}</template>
        </el-table-column>
        <el-table-column label="商户简称" min-width="160">
          <template slot-scope="scope">{{ scope.row.merchant_shortname || scope.row.short_name || scope.row.source_store_name || "-" }}</template>
        </el-table-column>
        <el-table-column label="商户名称" min-width="180">
          <template slot-scope="scope">{{ scope.row.merchant_name || scope.row.display_name || scope.row.name || "-" }}</template>
        </el-table-column>
        <el-table-column label="更新时间" min-width="150">
          <template slot-scope="scope">{{ scope.row.updated_at || scope.row.last_sync_at || "-" }}</template>
        </el-table-column>
      </el-table>
      <div class="candidate-pagination">
        <el-pagination
          background
          small
          layout="total, prev, pager, next"
          :current-page="candidateDialog.page"
          :page-size="candidateDialog.limit"
          :total="candidateDialog.total"
          @current-change="changeCandidatePage"
        />
      </div>
      <div class="admin-dialog-actions" slot="footer">
        <el-button size="small" @click="candidateDialog.show = false">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="candidateDialog.saving"
          :disabled="!candidateDialog.selected"
          @click="saveCandidate"
        >
          更换并启用
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { eltips } from "@/util/util.js";
import baseSearch from "@/components/common/baseSearch.vue";
import baseTable from "@/components/common/baseTable.vue";
import {
  disableMerchantBinding,
  enableMerchantBinding,
  listMerchantBindingCandidates,
  listMerchantBindings,
  saveMerchantBinding,
} from "@/api/weishop/wechatStoreMerchantBinding";
import {
  isRegionScope,
  resolveWeiShopApi,
} from "@/views/apps/weishop/region/utils/regionApiMap";

export default {
  name: "WechatStoreMerchantBinding",
  components: {
    baseSearch,
    baseTable,
  },
  data() {
    return {
      searchFrom: [
        {
          type: "select",
          Field: "store_id",
          label: "所属门店",
          style: { width: "200px" },
          options: [],
        },
        {
          type: "input",
          Field: "keyword",
          label: "搜索关键词",
          style: { width: "220px" },
          placeholder: "门店/商户号",
        },
        {
          type: "select",
          Field: "payment_ready",
          label: "支付就绪",
          style: { width: "140px" },
          clearable: true,
          options: [
            { label: "已就绪", value: 1 },
            { label: "未就绪", value: 0 },
          ],
        },
        {
          type: "input",
          Field: "platform_ratio",
          label: "分账比例",
          style: { width: "150px" },
          placeholder: "如 1 或 1%",
        },
      ],
      storeMap: {},
      search: {
        loading: false,
        total: 0,
        post: {
          page: 1,
          limit: 10,
          store_id: "",
          keyword: "",
          payment_ready: "",
          platform_ratio: "",
        },
        table: [],
        tableForm: [
          { label: "门店", prop: "store", minWidth: 220, align: "left",   showOverflowTooltip: true },
          { label: "当前收款商户号", prop: "merchanthao"  },
          { label: "名称", prop: "merchant", minWidth: 280, align: "left" },
          { label: "支付就绪", prop: "payment_ready" },
          { label: "主商城分账比例", prop: "platform_ratio" },
          { label: "启用状态", prop: "enabled" },
          { label: "绑定更新时间", prop: "updated_at"  },
          { label: "操作", prop: "action", width: 190, fixed: "right" },
        ],
      },
      candidateDialog: {
        show: false,
        loading: false,
        saving: false,
        store: null,
        list: [],
        selected: null,
        selectedKey: "",
        keyword: "",
        page: 1,
        limit: 5,
        total: 0,
      },
    };
  },
  computed: {
    isRegionAccount() {
      return isRegionScope();
    },
  },
  created() {
    if (this.$route && this.$route.query && this.$route.query.store_id) {
      this.search.post.store_id = this.$route.query.store_id;
    }
    this.loadStores();
    this.getList();
  },
  methods: {
    isOk(res) {
      return res && (res.code === 200 || res.status === 200);
    },
    responseMsg(res, fallback) {
      return (res && (res.msg || res.message)) || fallback;
    },
    normalizeList(res) {
      const data = (res && res.data) || {};
      const list = data.list || data.bindings || data;
      const rows = list.data || data.data || [];
      return {
        rows: Array.isArray(rows) ? rows : [],
        total: list.total || (Array.isArray(rows) ? rows.length : 0),
      };
    },
    searchFun(form) {
      this.search.post = Object.assign({}, this.search.post, form || {}, { page: 1 });
      this.getList();
    },
    getList() {
      this.search.loading = true;
      const params = this.compactParams(this.search.post);
      listMerchantBindings(params)
        .then((res) => {
          if (this.isOk(res)) {
            const data = this.normalizeList(res);
            this.search.table = data.rows;
            this.search.total = data.total;
          } else {
            eltips(this.responseMsg(res, "获取门店收款绑定失败"), "error");
          }
        })
        .finally(() => {
          this.search.loading = false;
        });
    },
    changePage(page) {
      this.search.post.page = page;
      this.getList();
    },
    loadStores() {
      this.axios
        .get(resolveWeiShopApi("/api/weishop/admin/plugin/store/information/index"), { params: { page: 1, limit: 500 } })
        .then((res) => {
          if (!this.isOk(res)) return;
          const list = (((res.data || {}).data || {}).data || (res.data || {}).data || []);
          const stores = Array.isArray(list) ? list : [];
          this.storeMap = {};
          stores.forEach((item) => {
            this.storeMap[item.id] = item.title;
          });
          this.updateStoreOptions(stores);
        });
    },
    updateStoreOptions(stores) {
      const options = stores.map((item) => ({
        label: item.title,
        value: item.id,
      }));
      this.searchFrom.forEach((item) => {
        if (item.Field === "store_id") {
          item.options = options;
        }
      });
    },
    compactParams(params) {
      const result = Object.assign({}, params || {});
      Object.keys(result).forEach((key) => {
        if (result[key] === "" || result[key] === undefined || result[key] === null) {
          delete result[key];
        }
      });
      return result;
    },
    storeId(row) {
      return Number((row && (row.store_id || row.id)) || 0);
    },
    storeName(row) {
      if (!row) return "-";
      const id = this.storeId(row);
      return row.store_title || row.store_name || row.title || this.storeMap[id] || (id ? `门店 #${id}` : "-");
    },
    binding(row) {
      return (row && (row.binding || row.current_binding)) || {};
    },
    bindingId(row) {
      const binding = this.binding(row);
      return binding.id || binding.binding_id || "";
    },
    merchant(row) {
      return (row && (row.profile || row.merchant_profile || row.current_profile)) || this.binding(row);
    },
	    merchantValue(row, key) {
	      const merchant = this.merchant(row);
	      return merchant[key] || this.binding(row)[key] || "";
	    },
	    merchantDisplayName(row) {
	      return this.merchantValue(row, "merchant_name") || this.merchantValue(row, "display_name") || this.merchantValue(row, "name") || "-";
	    },
    isEnabled(row) {
      const binding = this.binding(row);
      if (!this.bindingId(row)) return false;
      return Number(binding.is_enabled) === 1 || Number(binding.status) === 1 || Number(binding.status) === 20;
    },
    isPaymentReady(row) {
      const merchant = this.merchant(row) || row || {};
      const readinessStatus = this.firstDefined(merchant.payment_ready_status, merchant.readiness_status);
      if (readinessStatus !== "") {
        return [1, 50].includes(Number(readinessStatus));
      }
      const explicitReady = this.firstDefined(merchant.is_payment_ready, merchant.payment_ready);
      if (explicitReady !== "") {
        return Number(explicitReady) === 1;
      }
      return (
        Number(merchant.applyment_status) === 50 &&
        Number(merchant.sign_status) === 50 &&
        Number(merchant.profit_sharing_status) === 50
      );
    },
    platformRatio(row) {
      const rule = (row && (row.profit_sharing_rule || row.platform_profit_rule)) || {};
      return this.firstDefined(
        row && row.platform_profit_ratio,
        row && row.platform_ratio,
        row && row.profit_sharing_ratio,
        rule.platform_ratio
      );
    },
    firstDefined(...values) {
      for (let i = 0; i < values.length; i++) {
        if (values[i] !== undefined && values[i] !== null && values[i] !== "") {
          return values[i];
        }
      }
      return "";
    },
    ratioText(value) {
      if (value === undefined || value === null || value === "") return "-";
      const numberValue = Number(value);
      if (!Number.isFinite(numberValue)) return "-";
      return `${(numberValue * 100).toFixed(2)}%`;
    },
    openCandidates(row) {
      this.candidateDialog = {
        show: true,
        loading: false,
        saving: false,
        store: row,
        list: [],
        selected: null,
        selectedKey: "",
        keyword: "",
        page: 1,
        limit: 5,
        total: 0,
      };
      this.loadCandidates();
    },
    loadCandidates() {
      const storeId = this.storeId(this.candidateDialog.store);
      if (!storeId) {
        eltips("缺少门店信息", "error");
        return;
      }
      this.candidateDialog.loading = true;
      listMerchantBindingCandidates(this.compactParams({
        store_id: storeId,
        keyword: this.candidateDialog.keyword,
        page: this.candidateDialog.page,
        limit: this.candidateDialog.limit,
      }))
        .then((res) => {
          if (this.isOk(res)) {
            const data = (res && res.data) || {};
            const list = data.profiles || data.list || data.candidates || data.data || [];
            const rows = Array.isArray(list.data) ? list.data : (Array.isArray(list) ? list : []);
            this.candidateDialog.list = rows;
            this.candidateDialog.total = Number(list.total || data.total || this.candidateDialog.list.length || 0);
            this.candidateDialog.page = Number(list.current_page || data.current_page || this.candidateDialog.page || 1);
            this.candidateDialog.selected = null;
            this.candidateDialog.selectedKey = "";
          } else {
            eltips(this.responseMsg(res, "获取候选商户失败"), "error");
          }
        })
        .finally(() => {
          this.candidateDialog.loading = false;
        });
    },
    candidateKey(row) {
      return String(row && (row.profile_id || row.id || row.applyment_id || row.sub_mchid || ""));
    },
    handleCandidateChange(row) {
      this.selectCandidate(row);
    },
    changeCandidatePage(page) {
      this.candidateDialog.page = page;
      this.loadCandidates();
    },
    filterCandidates() {
      this.candidateDialog.page = 1;
      this.candidateDialog.selected = null;
      this.candidateDialog.selectedKey = "";
      this.loadCandidates();
    },
    selectCandidate(row) {
      this.candidateDialog.selected = row || null;
      this.candidateDialog.selectedKey = this.candidateKey(row);
    },
    saveCandidate() {
      const storeId = this.storeId(this.candidateDialog.store);
      const candidate = this.candidateDialog.selected;
      if (!storeId || !candidate) return;
      const payload = {
        store_id: storeId,
        profile_id: candidate.profile_id || (candidate.profile && candidate.profile.id) || candidate.id,
        applyment_id: candidate.applyment_id || "",
        sub_mchid: candidate.sub_mchid || "",
        enable: 1,
      };
      this.candidateDialog.saving = true;
      saveMerchantBinding(payload)
        .then((res) => {
          if (!this.isOk(res)) {
            eltips(this.responseMsg(res, "保存绑定失败"), "error");
            return;
          }
          eltips(this.responseMsg(res, "已更换并启用收款商户"), "success", "已更换并启用收款商户");
          this.candidateDialog.show = false;
          this.getList();
        })
        .finally(() => {
          this.candidateDialog.saving = false;
        });
    },
    enableRow(row) {
      enableMerchantBinding(this.bindingId(row)).then((res) => {
        if (this.isOk(res)) {
          eltips(this.responseMsg(res, "收款商户已启用"), "success", "收款商户已启用");
          this.getList();
        } else {
          eltips(this.responseMsg(res, "启用失败"), "error");
        }
      });
    },
    disableRow(row) {
      this.$confirm(`禁用后，${this.storeName(row)} 将不能继续使用该商户档案收款，是否继续？`, "确认禁用", { type: "warning" })
        .then(() => disableMerchantBinding(this.bindingId(row)))
        .then((res) => {
          if (this.isOk(res)) {
            eltips(this.responseMsg(res, "收款商户已禁用"), "success", "收款商户已禁用");
            this.getList();
          } else {
            eltips(this.responseMsg(res, "禁用失败"), "error");
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.wechat-store-merchant-binding-page {
  .cell-tips {
    // margin-top: 4px;
    color: #000;
    font-size: 14px;
    line-height: 18px;
  }

  .row-actions {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    white-space: nowrap;
  }

  .danger-action {
    color: #f56c6c;
  }

  ::v-deep .merchant-candidate-dialog {
    .el-dialog__body {
      padding: 16px 20px 10px;
    }

    .el-dialog__footer {
      padding: 12px 20px 16px;
    }
  }

  .candidate-toolbar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 14px;
    margin-bottom: 10px;
  }

  .candidate-meta {
    min-width: 0;
  }

  .candidate-store {
    color: #303133;
    font-size: 15px;
    font-weight: 600;
    line-height: 24px;
  }

  .candidate-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  .candidate-search {
    width: 260px;
  }

  .candidate-table {
    margin-top: 8px;
  }

  .candidate-pagination {
    margin-top: 10px;
    text-align: right;
  }
}
</style>
